var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSolarBellLinear = function SvgSolarBellLinear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4B0D3",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M5.938 15.041c.518 1.384 1.917 2.375 3.562 2.375 1.645 0 3.044-.991 3.563-2.375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB3A90",
    strokeWidth: 1.5,
    d: "M14.844 7.687v-.558c0-3.063-2.394-5.546-5.344-5.546S4.156 4.066 4.156 7.129v.558a3.483 3.483 0 0 1-.548 1.88l-.877 1.366c-.8 1.247-.189 2.941 1.204 3.336a20.427 20.427 0 0 0 11.13 0c1.393-.395 2.004-2.09 1.204-3.336l-.877-1.365a3.484 3.484 0 0 1-.549-1.88v-.001Z"
  })));
};
export default SvgSolarBellLinear;